export default {
  name: "Details-component",
  data() {
    return {
      to_date: this.moment_date(),
      from_date: this.moment_date(),
      cafeorder_items: [],
      selected_radio: "hammam",
      options_radio: [{
        text: "Hammam",
        value: "hammam"
      }, {
        text: "Piscine Couverte",
        value: "piscine_cov"
      }, {
        text: "Piscine Non-couverte",
        value: "piscine"
      }, {
        text: "Café",
        value: "cafe"
      }],
      items: [],
      fields: [["#", {
        label: "Vendeur",
        key: "Nom_complet",
        sortable: true
      }, {
        label: "Date",
        key: "rec_date",
        sortable: true
      }, {
        label: "Type",
        key: "gender",
        sortable: true
      }, {
        label: "Collectifs",
        key: "coll",
        sortable: true
      }, {
        label: "Individuels",
        key: "indi",
        sortable: true
      }, {
        label: "Enfants",
        key: "enf",
        sortable: true
      }, {
        label: "Remise",
        key: "remise",
        sortable: true
      }, {
        label: "Prix Total",
        key: "ttl",
        sortable: true
      }], ["#", {
        label: "Vendeur",
        key: "Nom_complet",
        sortable: true
      }, {
        label: "Date",
        key: "rec_date",
        sortable: true
      }, {
        label: "Type",
        key: "gender",
        sortable: true
      }, {
        label: "+10",
        key: "cat_1",
        sortable: true
      }, {
        label: "7-10",
        key: "cat_2",
        sortable: true
      }, {
        label: "2-7",
        key: "cat_3",
        sortable: true
      }, {
        label: "-2",
        key: "cat_4",
        sortable: true
      }, {
        label: "remise",
        key: "discount",
        sortable: true
      }, {
        label: "Prix Total",
        key: "ttl",
        sortable: true
      }], ["#", {
        label: "Vendeur",
        key: "Nom_complet",
        sortable: true
      }, {
        label: "Date",
        key: "rec_date",
        sortable: true
      }, {
        label: "+10",
        key: "cat_1",
        sortable: true
      }, {
        label: "7-10",
        key: "cat_2",
        sortable: true
      }, {
        label: "2-7",
        key: "cat_3",
        sortable: true
      }, {
        label: "-2",
        key: "cat_4",
        sortable: true
      }, {
        label: "Accompagnants",
        key: "acco",
        sortable: true
      }, {
        label: "remise",
        key: "discount",
        sortable: true
      }, {
        label: "Prix Total",
        key: "ttl",
        sortable: true
      }], ["#", {
        label: "Vendeur",
        key: "Nom_complet",
        sortable: true
      }, {
        label: "Date",
        key: "rec_date",
        sortable: true
      }, {
        label: "Prix Total",
        key: "ttl",
        sortable: true
      }, {
        label: "afficher Details",
        key: "action",
        sortable: true
      }]],
      cafeFields: ["#", {
        label: "Article",
        key: "item_name"
      }, {
        label: "Categorie",
        key: "item_cat"
      }, {
        label: "Prix Unitaire",
        key: "price"
      }, {
        label: "Quantité",
        key: "qtt"
      }, "prix"]
    };
  },
  computed: {
    nombrePiscine() {
      var nb = Object.create(null);
      nb.cat_1 = this.items.reduce((a, b) => {
        return a + b.cat_1;
      }, 0);
      nb.cat_2 = this.items.reduce((a, b) => {
        return a + b.cat_2;
      }, 0);
      nb.cat_3 = this.items.reduce((a, b) => {
        return a + b.cat_3;
      }, 0);
      nb.cat_4 = this.items.reduce((a, b) => {
        return a + b.cat_4;
      }, 0);
      nb.acco = this.items.reduce((a, b) => {
        return a + b.acco;
      }, 0);
      return nb;
    },
    nombrePiscineCov() {
      var nb = Object.create(null);
      nb.f = Object.create(null);
      nb.h = Object.create(null);
      nb.f.cat_1 = this.items.filter(el => el.gender == "F").reduce((a, b) => {
        return a + b.cat_1;
      }, 0);
      nb.f.cat_2 = this.items.filter(el => el.gender == "F").reduce((a, b) => {
        return a + b.cat_2;
      }, 0);
      nb.f.cat_3 = this.items.filter(el => el.gender == "F").reduce((a, b) => {
        return a + b.cat_3;
      }, 0);
      nb.f.cat_4 = this.items.filter(el => el.gender == "F").reduce((a, b) => {
        return a + b.cat_4;
      }, 0);
      nb.h.cat_1 = this.items.filter(el => el.gender == "H").reduce((a, b) => {
        return a + b.cat_1;
      }, 0);
      nb.h.cat_2 = this.items.filter(el => el.gender == "H").reduce((a, b) => {
        return a + b.cat_2;
      }, 0);
      nb.h.cat_3 = this.items.filter(el => el.gender == "H").reduce((a, b) => {
        return a + b.cat_3;
      }, 0);
      nb.h.cat_4 = this.items.filter(el => el.gender == "H").reduce((a, b) => {
        return a + b.cat_4;
      }, 0);
      return nb;
    },
    nombreHammam() {
      var nb = Object.create(null);
      nb.fcoll = this.items.filter(el => el.gender == "F").reduce((a, b) => {
        return a + b.coll + b.enf;
      }, 0);
      nb.findi = this.items.filter(el => el.gender == "F").reduce((a, b) => {
        return a + b.indi;
      }, 0);
      nb.hcoll = this.items.filter(el => el.gender == "H").reduce((a, b) => {
        return a + b.coll + b.enf;
      }, 0);
      nb.hindi = this.items.filter(el => el.gender == "H").reduce((a, b) => {
        return a + b.indi;
      }, 0);
      return nb;
    },
    total_price() {
      var nmb;
      nmb = this.items.reduce((a, b) => a + b.ttl, 0);
      return nmb;
    },
    nummberPersons() {
      var nmb = 0;
      switch (this.selected_radio) {
        case "hammam":
          nmb = this.items.reduce((a, b) => a + b.coll + b.indi + b.enf, 0);
          break;
        case "piscine_cov":
          nmb = this.items.reduce((a, b) => a + b.cat_1 + b.cat_2 + b.cat_3 + b.cat_4, 0);
          break;
        case "piscine":
          nmb = this.items.reduce((a, b) => a + b.cat_1 + b.cat_2 + b.cat_3 + b.cat_4 + b.acco, 0);
          break;
      }
      return nmb;
    },
    selected_fields() {
      var arr = [];
      switch (this.selected_radio) {
        case "hammam":
          arr = this.fields[0];
          break;
        case "piscine_cov":
          arr = this.fields[1];
          break;
        case "piscine":
          arr = this.fields[2];
          break;
        case "cafe":
          arr = this.fields[3];
          break;
      }
      return arr;
    },
    nummberRemises() {
      var nb;
      nb = this.items.reduce((a, b) => a + b.remise, 0);
      return nb;
    }
  },
  watch: {
    selected_radio(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search(); // Automatically trigger the search method
      }
    }
  },
  methods: {
    error() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
    formatNumber: function (value) {
      if (isNaN(value)) return value;
      return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    moment_date: function (date) {
      var moment = require("moment");
      return moment(date).format("YYYY-MM-DD");
    },
    showDetails(item) {
      const axios = require("axios");
      axios.post(this.$store.state.api_url + "/details_caisse/cafeorder_items", {
        order_id: item.order_id
      }, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        const data = response.data;
        this.cafeorder_items = data;
        console.log(data);
        //this.isbusy = false;
        this.$root.$emit("bv::show::modal", "cafeDetailsModal");
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
        }
      });
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_off === "no") return "table-warning";
    },
    search() {
      const axios = require("axios");

      //this.isbusy = true;

      axios.post(this.$store.state.api_url + "/details_caisse/" + this.selected_radio, {
        ldate: this.moment_date(this.from_date),
        rdate: this.moment_date(this.to_date)
      }, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token
        }
      }).then(response => {
        const data = response.data;
        this.items = data;

        //this.isbusy = false;
      }).catch(err => {
        if (err.response.status === 401) {
          console.log("uNauthorized request");
          console.log(err);
          this.error();
        } else {
          console.log("error : " + err);
        }
      });
    }
  }
};